<template functional>
  <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M9.25 10.313a3.79 3.79 0 0 0 .688-1.657h1.343a5.381 5.381 0 0 1-1.062 2.594l-.969-.938Zm-2.594 1.624a3.79 3.79 0 0 0 1.657-.687l.968.969c-.75.583-1.625.937-2.625 1.062v-1.344Zm4.625-4.593H9.937a3.79 3.79 0 0 0-.687-1.657l.969-.937c.604.75.958 1.615 1.062 2.594ZM8.375 3.687l-3.031 2.97V4.061a3.994 3.994 0 0 0-2.407 1.375C2.313 6.168 2 7.021 2 8c0 .98.313 1.844.938 2.594a4.056 4.056 0 0 0 2.406 1.344v1.343c-1.313-.166-2.427-.75-3.344-1.75C1.104 10.531.656 9.354.656 8S1.104 5.469 2 4.469c.917-1 2.031-1.584 3.344-1.75V.656l3.031 3.031Z" />
  </svg>
</template>

<script>
export default {
  name: 'BaseLoaderLite'
}
</script>

<style lang="scss" scoped>
svg {
  fill: nth($colors-custom, 1);
  transform-origin: center 60%;
  animation: rotate 2s linear infinite;

  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
